module.exports = __webpack_public_path__ + "static/video-nfts-foreground-9a613a0d735f71eccad290cb8a4aa8bd.png";